var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModelGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.541,
    height: 81.462
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16948",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16892",
    opacity: 0.199,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16889"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12548",
    d: "M75.309 35.355h3.231"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12549",
    d: "M76.925 33.739v3.231"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16890"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12546",
    d: "M65.056 1v12.113"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12547",
    d: "M59 7.057h12.113"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16891"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12546",
    d: "M4.231 62v6.462"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12547",
    d: "M1 65.231h6.462"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Earth, Pin, Location, Direction",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12592",
    d: "M73 81.462H3v-70h70z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12593",
    d: "M46.75 40.629s10.214-8.385 10.214-16.042a10.214 10.214 0 00-20.428 0c0 7.656 10.214 16.042 10.214 16.042z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12594",
    d: "M46.753 24.149a.729.729 0 11-.732.729.725.725 0 01.732-.729",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12595",
    d: "M36.632 23.202a26.268 26.268 0 1018.935 6.72",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12596",
    d: "M26.334 72.906v-.2c0-5.833 11.667-5.145 11.667-11.667 0-5.833-8.75-5.833-8.75-14.583-.001-8.25-5.834-8.75-14.584-8.75h-.178",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12597",
    d: "M55.412 68.979a8.606 8.606 0 01-1.295-.592 8.784 8.784 0 118.87-15.164 9.028 9.028 0 01.849.618",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
export default SvgModelGroup;


//////////////////
// WEBPACK FOOTER
// ./src/icons/model-group.svg
// module id = 779
// module chunks = 13